<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Pincodes</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <v-btn class="button is-small" :disabled="!(searchFilterArray.length > 0)" @click="exportToCSV()" color="primary" elevation="1">
              <v-icon left>mdi-download</v-icon>
              Export CSV
            </v-btn>
          </div>
          <div class="level-item">
            <router-link slot="right" :to="{ name: 'UploadPincodes' }" class="button is-small v-btn theme--light elevation-1 v-size--default primary" color="primary" elevation="1">
              Upload CSV
            </router-link>
          </div>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
      <div class="level-right">
        <div class="level-item">
          <b-input placeholder="Search..." type="search" v-model="searchTerm" @input="customSearch(searchTerm)"></b-input>
        </div>
        <div class="level-item">
          <router-link slot="right" :to="{ name: 'AddPincodes' }" class="button is-small v-btn theme--light elevation-1 v-size--default primary" color="primary" elevation="1">
            Add Pincodes
          </router-link>
          <!-- <router-link slot="right" :to="{ name: 'AddPincodes' }" class="button is-small is-link"> Add Pincodes</router-link> -->
        </div>
      </div>
    </section>
    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <b-table :paginated="paginated" :per-page="10" :hoverable="true" default-sort="updatedAt" default-sort-direction="DESC" :data="searchFilterArray">
          <template slot-scope="props">
            <b-table-column label="Franchisee Name" field="companyName" sortable> {{ props.row.franchisee.companyName }} </b-table-column>
            <b-table-column label="Pincode" field="Pincode" sortable> {{ props.row.pincode }}</b-table-column>
            <b-table-column label="State" field="state" sortable>
              {{ props.row.state ? props.row.state : '--' }}
            </b-table-column>
            <b-table-column label="City" field="city" sortable>
              {{ props.row.city ? props.row.city : '--' }}
            </b-table-column>
            <b-table-column class="location" label="Location" field="location" sortable>
              {{ props.row.location ? props.row.location : '--' }}
            </b-table-column>
            <b-table-column label="Status" field="Status" sortable> {{ props.row.status ? 'Active' : 'Deactive' }} </b-table-column>
            <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered>
              <div class="buttons">
                <router-link :to="{ name: 'EditPincodes', params: { pincodeId: props.row.id } }" class="button is-info is-small btnicon" title="Edit" v-if="!props.row.deletedAt">
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
                <button class="button is-small is-danger" type="button" v-if="!props.row.deletedAt" @click.prevent="deletePincode(props.row.id)" title="Delete">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
                <button class="button is-small is-success" type="button" @click.prevent="restorePincode(props.row.id)" v-if="props.row.deletedAt" title="Restore">
                  <b-icon icon="restore" size="is-small" />
                </button>
              </div>
            </b-table-column>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'ListTemplate',
  components: {
    CardComponent
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchTerm: '',
      pincodeId: '',
      searchFilterArray: [],
      data: [],
      total: 0,
      isLoading: false,
      paginated: true,
      checkedRows: [],
      tempPincode: [],
      loadingComponent: null,
      inProgress: false
    }
  },

  async created () {
    this.loadingComponent = this.$buefy.loading.open()
    await this.getPincodes()
    await this.onFranchiseeChange()
    this.loadingComponent.close()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      console.log(this.franchisee)
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee.id && this.franchisee.id !== null) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        // this.clearAll()
        this.inProgress = false
        this.getPincodes()
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.tempPincode
      } else {
        this.searchFilterArray = _.filter(
          this.tempPincode,
          item =>
            (item &&
              item.pincode
                .toString()
                .toLowerCase()
                .search(value) >= 0) ||
            (item && item.franchisee.companyName.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.city && item.city.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.state && item.state.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.location && item.location.toLowerCase().search(value.toLowerCase()) >= 0)
        )
        this.total = this.searchFilterArray.length
      }
    },
    addPincode: function () {
      this.$router.push({ name: 'addPincodes' })
    },
    getPincodes: async function () {
      try {
        let response = ''
        if (this.franchiseeID && this.franchiseeID !== null) {
          this.pinObj = {}
          this.pinObj.franchiseeID = this.franchiseeID
          response = await http.post(`${constants.API_URL}/api/pincodes/centerwise`, this.pinObj)
          console.log(response)
        } else {
          response = await http.get(`${constants.API_URL}/api/pincodes`)
        }
        this.data = response.data
        this.tempPincode = response.data
        this.searchFilterArray = this.tempPincode
        this.total = response.data.length
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        return this.errMsg(`Error While fetching Template : ${errorMessage}`)
      }
    },
    exportToCSV () {
      const csvData = []
      this.searchFilterArray.forEach(t => {
        console.log(t.status)
        csvData.push({
          franchiseeID: t.franchiseeID,
          pincode: t.pincode,
          status: t.status === false ? 'No' : 'Yes',
          location: t.location ? t.location : '',
          city: t.city ? t.city : '',
          state: t.state ? t.state : ''
        })
      })

      ExportUtility.convertToCsv(csvData, 'pincode-list')
    },
    deletePincode: async function (pincodeId) {
      let ref = this
      this.$buefy.dialog.confirm({
        title: 'Delete Pincode',
        message: 'Do you really want to <b>delete</b> this record?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.delete(`${constants.API_URL}/api/pincodes/${pincodeId}`)
            ref.loadingComponent.close()
            await ref.getPincodes()
            return ref.okMsg(`Deactivated Pincode Successfully`)
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            ref.loadingComponent.close()
            return this.errMsg(errorMessage)
          }
        }
      })
    },
    restorePincode: async function (pincodeId) {
      let ref = this
      this.$buefy.dialog.confirm({
        title: 'Restore Pincode',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-warning',
        hasIcon: true,
        message: 'Do you want to restore Pincode?',
        onConfirm: async function () {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.put(`${constants.API_URL}/api/pincodes/${pincodeId}/restore`)
            ref.loadingComponent.close()
            await ref.getPincodes()
            return ref.okMsg(`Pincode Restored successfully!`)
          } catch (e) {
            ref.loadingComponent.close()
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.errMsg(`Error While restore of pincode : ${errorMessage}`)
          }
        }
      })
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
